// Count Tool — counting tool for science/analysis.
// Shares shortcut I with Eyedropper. Click to place count markers.

import { screenToDoc } from "../render/Viewport";
import type { PointerSample, Tool, ToolContext } from "./Tool";

export interface CountMarker {
  id: string;
  x: number;
  y: number;
  label: number;
}

export class CountTool implements Tool {
  readonly id = "count";
  readonly shortcut = "I";

  /** Count markers for the current document. */
  markers: CountMarker[] = [];

  onPointerDown(ctx: ToolContext, s: PointerSample): void {
    if (!ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);

    // Check if clicking on existing marker to remove it
    for (let i = this.markers.length - 1; i >= 0; i--) {
      const m = this.markers[i]!;
      if (Math.abs(m.x - p.x) < 10 && Math.abs(m.y - p.y) < 10) {
        this.markers.splice(i, 1);
        // Renumber remaining markers
        this.markers.forEach((mk, idx) => { mk.label = idx + 1; });
        ctx.requestRender();
        return;
      }
    }

    // Add new marker
    this.markers.push({
      id: crypto.randomUUID(),
      x: p.x, y: p.y,
      label: this.markers.length + 1,
    });
    ctx.requestRender();
  }

  /** Clear all markers. */
  clearAll(): void {
    this.markers = [];
  }

  /** Get total count. */
  get count(): number {
    return this.markers.length;
  }
}
